import { Component, Input } from '@angular/core';

export const normalizeSize = (size: number | string): string => (parseFloat(size.toString()).toString() === size.toString() ? `${size}px` : size.toString());

@Component({
    selector: 'ca-spinner-circular',
    templateUrl: './spinner-circular.component.html',
    styleUrls: ['./spinner-circular.component.css'],
})
export class SpinnerCircularComponent {
    @Input() secondaryColor = 'rgba(0,0,0,0.44)';

    @Input() color = '#38ad48';
    @Input() enabled = true;
    @Input() size: number | string = 50;
    @Input() speed = 100;
    @Input() still = false;
    @Input() styles = {};
    @Input() thickness = 100;

    get svgStyle(): object {
        return {
            color: this.color,
            overflow: 'visible',
            width: normalizeSize(this.size),
            height: normalizeSize(this.size),
            ...(typeof this.styles === 'string' ? JSON.parse(this.styles) : this.styles),
        };
    }

    get strokeWidth(): number {
        return 4 * (this.thickness / 100);
    }

    get dashStyle(): object {
        return {
            color: this.color,
            ...(!this.still ? { animation: `spinners-angular-circular ${140 / this.speed}s linear infinite` } : {}),
        };
    }
}
